// traces.js

import moment from "moment";
import { createSelector } from "reselect";

import { entityFactory } from "./entity";
import { encodeUrl } from "../helpers/fetch.js";

const fetchActionCreator = type => {
  return (
    start,
    end,
    orgId,
    svcId,
    sortBy,
    sortOrder,
    minResponseTime,
    maxResponseTime,
    httpStatus,
    length,
    filterBy
  ) => {
    return {
      type,
      start,
      end,
      orgId,
      svcId,
      sortBy,
      sortOrder,
      minResponseTime,
      maxResponseTime,
      httpStatus,
      length,
      filterBy,
    };
  };
};

const urlCreator = action => {
  let params = {
    start_time: moment(action.start).unix(),
    end_time: moment(action.end).unix(),
    orderby: action.sortBy,
    sort: action.sortOrder,
    length: action.length,
  };

  // optional parameters
  if (action.minResponseTime) {
    params = Object.assign(params, {
      min_response_time: action.minResponseTime,
    });
  }
  if (action.maxResponseTime) {
    params = Object.assign(params, {
      max_response_time: action.maxResponseTime,
    });
  }
  if (action.httpStatus) {
    params = Object.assign(params, { http_status: action.httpStatus });
  }
  if (action.filterBy && Object.keys(action.filterBy).length > 0) {
    params = {
      ...params,
      ...action.filterBy,
    };
  }

  return encodeUrl(`/v1/apm/services/${action.svcId}/traces`, params);
};

const { reducer, watcher, fetcher } = entityFactory(
  "traces",
  fetchActionCreator,
  urlCreator,
  "trace_id"
);

export default reducer;
export const tracesWatcher = watcher;
export const fetchTraces = fetcher;

// selectors
const getTracesById = state => state.entities.traces.byId;
const getTracesAllIds = state => state.entities.traces.allIds;

export const getTraces = createSelector(
  [getTracesById, getTracesAllIds],
  (tracesById, tracesAllIds) => tracesAllIds.map(id => tracesById[id])
);
